




import { setupHeaderLine } from './modules/header-line';
import { setupImageSlider } from './modules/image-slider';
import { setupBlockGrid } from './modules/block-grid';
import { setupSearch } from './modules/header-search';
import { setupMobileNav } from './modules/mobile-nav';





window.addEventListener('DOMContentLoaded', () => {
    setupImageSlider();
    setupBlockGrid();
    setupSearch();
    setupMobileNav();
});

window.addEventListener('load', () => {
    setupHeaderLine();
});
